import TodayHighlightsCard from '@/features/broker-rail/components/TodayHighlightsCard'
import TopRatedBrokersCard from '@/features/broker-rail/components/TopRatedBrokersCard'
import { cn } from '@/lib/utils'

/**
 * The Broker Analysis rail (the mock's `bra-rail`, 2026-10-28): Today's highlights over Top rated
 * brokers, 40 apart like every rail's blocks. It replaces the shared Market news + Popular stocks
 * on every page under `/brokers` — `ScreenLayout` picks it by the shell's URL (`isBrokerRoute`), as
 * `MarketRail` picks its Market blocks, so a new Broker page, its pending skeleton and its error
 * page all draw it with nothing to pass.
 *
 * Its own `<aside>`, named, as `MarketRail` is: the layout renders it into a bare track. Fitted
 * to the window by the same `useRailFit` (block ids `highlights` and `top-rated`).
 */
export default function BrokerRail({ className }: { className?: string }) {
  return (
    <aside aria-label="Broker rail" className={cn('flex flex-col gap-10', className)}>
      <TodayHighlightsCard />
      <TopRatedBrokersCard />
    </aside>
  )
}
